module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS2.f7067eed.jpg";